<div class='application-details' *ngIf='application() as application'>
  <div class='row'>
    <div class='col-md-3'>
      <app-label label='Data utworzenia:'>
        {{ application?.createdAt | date }}
      </app-label>
    </div>
    <div class='col-md-3'>
      <app-label label='Data zatwierdzenia:'>
        {{ application?.updatedAt | date }}
      </app-label>
    </div>
    <div class='col-md-6'>
      <app-label label='Numer sprawy:'>
        {{ application?.caseNumber }}
      </app-label>
    </div>
  </div>
  <ng-container *ngIf='shipments()?.length'>
    <br>
    <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
    </app-decision-data-preview>
    <br>
  </ng-container>
  <app-applicant-preview
    [application]="application"
    [expanded]="expanded">
  </app-applicant-preview>
  <br>
  <h3>
    Dane wniosku
  </h3>
  <app-application-data-preview [application]="application">
  </app-application-data-preview>
  <br>
  <h3>
    Inwestor
  </h3>
  <app-contractor-data-preview tag="investor" [application]="application">
  </app-contractor-data-preview>
  <br>
  <h3>
    Zajęcia
  </h3>
  <app-accordion-group>
    <app-accordion-item
      *ngFor=' let occupation of roadOccupations(); let i = index'
      [name]="i + 1 + '. ' + occupation.deviceType"
      [expanded]='expanded'
      [disabled]='false'>
      <app-location-of-devices-unrelated-to-road-occupation-preview [occupation]='occupation'>
      </app-location-of-devices-unrelated-to-road-occupation-preview>
    </app-accordion-item>
  </app-accordion-group>
  <br>
  <h3>
    Zgody
  </h3>
  <app-agreements-data-preview [application]="application">
  </app-agreements-data-preview>
  <br>
  <h3>
    Załączniki
  </h3>
  <app-attachments-data-preview [application]="application">
  </app-attachments-data-preview>
</div>
